import React from "react";

/**
 * TodayYouEntryRow —— 聊天底部"镜子里的你想说一句话"入口行（拉式入口·阶段切换后）
 *
 * 设计哲学（对齐母提示词手术 3）：
 *   - 不弹窗、不打断聊天流：仅在 visible=true 时占据一行
 *   - 不夸奖、不打分、不带 emoji 评判：低饱和度配色，文字克制
 *   - 单一动作：点击 → 打开"我的成长中心 → 我的故事"，并清除未读标记
 *   - 出现条件：后端阶段切换时 WS 推送 today_you_card → setHasUnreadTodayYou(true)
 *
 * Props:
 *   visible      boolean  是否显示
 *   onOpen()              点击回调（建议宿主：openGameCenter+markRead）
 *   onDismiss()           可选：右侧 ✕ 关闭回调（不阅读、不入档）
 */
const TodayYouEntryRow = ({ visible, onOpen, onDismiss }) => {
  if (!visible) return null;

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={onOpen}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onOpen?.();
        }
      }}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 12,
        margin: "8px 16px 4px 16px",
        padding: "10px 14px",
        borderRadius: 10,
        background:
          "linear-gradient(90deg, rgba(155,135,245,0.08) 0%, rgba(155,135,245,0.04) 100%)",
        border: "1px solid rgba(155,135,245,0.25)",
        cursor: "pointer",
        userSelect: "none",
        fontFamily:
          "'Noto Serif SC', 'Source Han Serif SC', Georgia, serif",
        color: "#5b4ea6",
        fontSize: 13.5,
        lineHeight: 1.5,
        transition: "background-color 0.15s ease, transform 0.15s ease",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background =
          "linear-gradient(90deg, rgba(155,135,245,0.14) 0%, rgba(155,135,245,0.08) 100%)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background =
          "linear-gradient(90deg, rgba(155,135,245,0.08) 0%, rgba(155,135,245,0.04) 100%)";
      }}
    >
      <span style={{ display: "flex", alignItems: "center", gap: 8, minWidth: 0 }}>
        <span
          style={{
            width: 6,
            height: 6,
            borderRadius: "50%",
            background: "#9b87f5",
            flexShrink: 0,
            animation: "todayYouPulse 1.6s ease-in-out infinite",
          }}
        />
        <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
          ↳ 镜子里的你想说一句话 · 点击查看
        </span>
      </span>

      <span style={{ display: "flex", alignItems: "center", gap: 8, flexShrink: 0 }}>
        <span
          style={{
            color: "#9b87f5",
            fontSize: 12,
            opacity: 0.85,
          }}
        >
          打开 →
        </span>
        {onDismiss && (
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              onDismiss();
            }}
            aria-label="暂不查看"
            title="暂不查看"
            style={{
              background: "transparent",
              border: "none",
              color: "#9b87f5",
              opacity: 0.55,
              cursor: "pointer",
              fontSize: 14,
              padding: "0 4px",
              lineHeight: 1,
            }}
          >
            ✕
          </button>
        )}
      </span>

      <style>{`
        @keyframes todayYouPulse {
          0%, 100% { opacity: 0.55; transform: scale(1); }
          50% { opacity: 1; transform: scale(1.25); }
        }
      `}</style>
    </div>
  );
};

export default TodayYouEntryRow;
